import React, { useState } from "react";
import { TspCard } from "../../../components/primitives";
import { RESPONSE_RATINGS } from "../../../constants/tspOperations";
import { formatDate } from "../../../utils/tspFormat";

// Records a public response against a journey's recorded city visit. The
// original mock screen had no add form at all (list + breakdown only) — this
// is the minimum needed for "Support: create" (Phase 3 brief, Section 8),
// built from the same journey/visit picker pattern the other Phase 3 forms
// already use.
export default function PublicResponseFormCard({ journeys, journeyId, onJourneyChange, visits, visitId, onVisitChange, visitsLoading, onSubmit }) {
  const [rating, setRating] = useState("");
  const [remarks, setRemarks] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const requiredFilled = journeyId && visitId && rating;

  const handleSubmit = async () => {
    if (!requiredFilled || busy) return;
    setBusy(true);
    setError("");
    const result = await onSubmit({ journey_id: Number(journeyId), city_visit_id: Number(visitId), response_rating: rating, ...(remarks.trim() ? { remarks: remarks.trim() } : {}) });
    setBusy(false);
    if (result.ok) {
      setRating("");
      setRemarks("");
    } else {
      setError(result.message);
    }
  };

  return (
    <TspCard title="Record Public Response">
      <div className="tsp-form-row">
        <div className="tsp-form-field">
          <label htmlFor="pr-journey">Journey</label>
          <select id="pr-journey" className="tsp-select tsp-select-block" value={journeyId} disabled={busy} onChange={(e) => onJourneyChange(e.target.value)}>
            <option value="">Select Journey</option>
            {journeys.map((journey) => (
              <option key={journey.id} value={journey.id}>
                {journey.journey_name}
              </option>
            ))}
          </select>
        </div>
        <div className="tsp-form-field">
          <label htmlFor="pr-visit">City Visit</label>
          <select id="pr-visit" className="tsp-select tsp-select-block" value={visitId} disabled={busy || !journeyId || visitsLoading} onChange={(e) => onVisitChange(e.target.value)}>
            <option value="">{visitsLoading ? "Loading…" : "Select City Visit"}</option>
            {visits.map((visit) => (
              <option key={visit.id} value={visit.id}>
                {visit.location.label} — {formatDate(visit.visit_date)}
              </option>
            ))}
          </select>
        </div>
        <div className="tsp-form-field">
          <label htmlFor="pr-rating">Response</label>
          <select id="pr-rating" className="tsp-select tsp-select-block" value={rating} disabled={busy} onChange={(e) => setRating(e.target.value)}>
            <option value="">Select Response</option>
            {RESPONSE_RATINGS.map((r) => (
              <option key={r.value} value={r.value}>
                {r.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="tsp-form-field" style={{ marginTop: 14 }}>
        <label htmlFor="pr-remarks">Remarks</label>
        <input id="pr-remarks" type="text" className="tsp-input" value={remarks} disabled={busy} onChange={(e) => setRemarks(e.target.value)} />
      </div>
      {error && (
        <p className="tsp-form-error" role="alert">
          {error}
        </p>
      )}
      <button type="button" className="tsp-btn tsp-btn-success" style={{ marginTop: 14 }} onClick={handleSubmit} disabled={!requiredFilled || busy}>
        {busy ? "Saving…" : "Add Response"}
      </button>
    </TspCard>
  );
}
